import { useContext } from 'react';

import { UserDetails, UserDetailsContext } from '@shared/providers/UserDetailsProvider/providerSetup.ts';

export const useUserDetails = (): UserDetails => {
  const context = useContext(UserDetailsContext);

  if (!context) {
    throw new Error('useUserDetails must be used within a UserDetailsProvider');
  }

  return context;
};
